const setupProps = {
  columns: {
    type: 'Array',
    children: {
      type: 'Object',
      props: {
        label: { type: 'String' },
        name: { type: 'String' },
        sortable: { type: 'Boolean', default: false },
        active: { type: 'Boolean', default: false },
        width: { type: 'Number', default: 200 },
      },
    },
  },
};

// Exported
export default { ...setupProps };
